export const NotificationsHash = 'notifications=show';
export const transformer = {
    from: (parsed)=>{
        if (typeof parsed.notifications !== 'string') {
            return [
                'invalid'
            ];
        }
        return [
            'show'
        ];
    },
    to: (params)=>{
        switch(params[0]){
            case 'show':
                return {
                    notifications: 'show'
                };
            default:
                return {
                    notifications: null
                };
        }
    }
};
